import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import style from "../../../../css/dashboard/Screener.module.css";
import { fetch_screener_stocks, fetch_live_price } from "../../../ApisService/apiService";
import TradingViewWidget from "../TradingViewWidget";
import { useNavigate } from "react-router-dom";

const Rocket = ({ strategy = "" }) => {
  const [stocks, setStocks] = useState([]);
  const [livePrices, setLivePrices] = useState({});
  const [selectedStock, setSelectedStock] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    fetchScreenerData();
  }, [strategy]);

  const fetchScreenerData = async () => {
    try {
      const data = await fetch_screener_stocks(strategy);
      if (data) {
        setStocks(data);
        fetchLivePrices(data);
      }
    } catch (error) {
      console.error("Error fetching screener data:", error);
    }
  };

  const fetchLivePrices = async (stocksData) => {
    const prices = {};
    for (const stock of stocksData) {
      try {
        const priceData = await fetch_live_price(stock.code);
        if (priceData.live_price) {
          const livePrice = priceData.live_price.BIDPRICE || 0;
          const openPrice = priceData.live_price.OPEN || 0;
          const percentageChange = openPrice
            ? ((livePrice - openPrice) / openPrice) * 100
            : 0;
          prices[stock.code] = {
            livePrice,
            percentageChange,
          };
        }
      } catch (error) {
        console.error(`Error fetching price for ${stock.code}:`, error);
      }
    }
    setLivePrices(prices);
  };

  return (
    <div className={style.screenerWrapper}>
       <button
                type="button"
                onClick={() => navigate(-1)}
                aria-label="Go back"
                style={{
                  position: 'fixed', 
                  right: '30px',
                  background: 'transparent',
                    backgroundColor: 'var(--gold)',
                  border: 'none',
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'transform 0.2s ease-in-out',
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1.0)'}
              >
                <i
                  className="fa fa-arrow-left"
                  aria-hidden="true"
                  style={{
                    fontSize: '22px',
                    color: 'white',
                  }}
                ></i>
              </button>
      <AnimatePresence>
        {!selectedStock && (
          <motion.div
            className={style.screenerContainer}
            initial={{ x: 0, opacity: 1 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: "-100%", opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h2 className={style.heading}>📈 Screener Stocks {strategy && `- ${strategy}`}</h2>
            <div className={style.tableWrapper}>
              <table className={style.screenerTable}>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Company Name</th>
                    <th>Symbol</th>
                    <th>Industry</th>
                    <th>Price</th>
                    {/* <th>Change</th>
                    <th>RESULT</th> */}

                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {stocks.length > 0 ? (
                    stocks.map((stock, index) => {
                      const priceData = livePrices[stock.code] || {};
                      const { livePrice = "N/A", percentageChange = 0 } = priceData;
                      const isUp = percentageChange > 0;

                      return (
                        <tr key={stock.id} className={style.row}>
                          <td>{index + 1}</td>
                          <td
                            className={style.companyName}
                            onClick={() => setSelectedStock(`NSE:${stock.symbol}`)}
                          >
                            {stock.name}
                          </td>
                          <td>{stock.symbol}</td>
                          <td>{stock.industry}</td>
                          <td>₹{livePrice}</td>
                          {/* <td className={isUp ? style.greenText : style.redText}>
                            {percentageChange.toFixed(2)}%{" "}
                            <i className={`fas ${isUp ? "fa-arrow-up" : "fa-arrow-down"}`}></i>
                          </td>
                          <td style={{ fontWeight: "bold", color: stock.trade_result === "Profit" ? "green" : "red" }}>
                            {stock.trade_result} {stock.percentage}%
                          </td> */}

                          <td>{new Date(stock.created_at).toLocaleDateString()}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="8" className={style.noData}>
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {selectedStock && (
          <motion.div
            className={style.chartContainer}
            initial={{ x: "100%", opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: "100%", opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <button className={style.backButton} onClick={() => setSelectedStock(null)}>
              ⬅ Back
            </button>
            <TradingViewWidget stockSymbol={selectedStock} />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Rocket;
